export default __webpack_public_path__ + "static/media/walletConnectIcon.abc1518e.svg";